import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';
import { MailtemplateFormComponent } from '../../../components/mailtemplates/mailtemplate-form/mailtemplate-form.component';

@Component({
  selector: 'app-templates-index',
  standalone: true,
  imports: [
    CommonModule,
    MailtemplateFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './templates-index.component.html',
  styleUrl: './templates-index.component.scss'
})
export class TemplatesIndexComponent {
  items : []  = [];
	private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = MailtemplateFormComponent;

  constructor () {}  

	openModal(item: any) {    
    let self = this;
    console.log(self.reloadItems);
		const modalRef = this.modalService.open(MailtemplateFormComponent);
		modalRef.componentInstance.modalStyle = true;
		modalRef.componentInstance.item = item;
    modalRef.componentInstance.modalInstance = modalRef;
		modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
	}
}
